var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShipping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 48,
    viewBox: "0 0 65 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shipping",
    transform: "translate(-76.175 -3774.844)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dwrean_aposoli",
    "data-name": "dwrean aposoli",
    transform: "translate(76.175 3774.844)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_161552",
    "data-name": "Rectangle 161552",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 48,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 64,
    height: 47,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_175821",
    "data-name": "Group 175821",
    transform: "translate(5.923 8.215)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_175820",
    "data-name": "Group 175820",
    transform: "translate(0 7.373)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_32",
    "data-name": "Line 32",
    d: "M20.7,1.223H.236a.986.986,0,1,1,0-1.973H20.7a.986.986,0,1,1,0,1.973Z",
    transform: "translate(0.75 0.75)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_33",
    "data-name": "Line 33",
    d: "M20.7,1.223H.236a.986.986,0,0,1,0-1.973H20.7a.986.986,0,1,1,0,1.973Z",
    transform: "translate(6.942 5.261)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_34",
    "data-name": "Line 34",
    d: "M20.7,1.223H.236a.986.986,0,1,1,0-1.973H20.7a.986.986,0,1,1,0,1.973Z",
    transform: "translate(0.75 9.771)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_38307",
    "data-name": "Path 38307",
    d: "M222.474,324.583h-5.5a3.078,3.078,0,0,1-3.075-3.074v-7.292a.986.986,0,1,1,1.973,0v7.292a1.1,1.1,0,0,0,1.1,1.1h5.5a.986.986,0,1,1,0,1.973Z",
    transform: "translate(-206.887 -296.549)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38308",
    "data-name": "Path 38308",
    d: "M264.866,229.339H254.23a.986.986,0,1,1,0-1.973h10.636a1.1,1.1,0,0,0,1.1-1.1V204.379a1.1,1.1,0,0,0-1.1-1.1H241.508a.986.986,0,0,1,0-1.973h23.358a3.078,3.078,0,0,1,3.074,3.074v21.885A3.078,3.078,0,0,1,264.866,229.339Z",
    transform: "translate(-229.857 -201.305)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38309",
    "data-name": "Path 38309",
    d: "M214.888,210.251a.986.986,0,0,1-.986-.986v-4.885a3.078,3.078,0,0,1,3.075-3.074h2.714a.986.986,0,0,1,0,1.973h-2.714a1.1,1.1,0,0,0-1.1,1.1v4.885A.986.986,0,0,1,214.888,210.251Z",
    transform: "translate(-206.887 -201.305)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38310",
    "data-name": "Path 38310",
    d: "M274.106,349.856a4.908,4.908,0,1,1-4.908,4.908A4.914,4.914,0,0,1,274.106,349.856Zm0,7.843a2.935,2.935,0,1,0-2.935-2.935A2.939,2.939,0,0,0,274.106,357.7Z",
    transform: "translate(-254.207 -327.717)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_124",
    "data-name": "Ellipse 124",
    d: "M4.908,0A4.908,4.908,0,1,1,0,4.908,4.914,4.914,0,0,1,4.908,0Zm0,7.843A2.935,2.935,0,1,0,1.973,4.908,2.939,2.939,0,0,0,4.908,7.843Z",
    transform: "matrix(0.998, -0.055, 0.055, 0.998, 39.16, 22.417)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_35",
    "data-name": "Line 35",
    d: "M8.74,1.223H.236a.986.986,0,1,1,0-1.973h8.5a.986.986,0,0,1,0,1.973Z",
    transform: "translate(31.612 26.811)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38311",
    "data-name": "Path 38311",
    d: "M426.116,269.634h-1.957a.986.986,0,1,1,0-1.973h1.957a.891.891,0,0,0,.89-.89v-6.729a.891.891,0,0,0-.889-.89h-.377a.986.986,0,0,1-.814-.431l-5.25-7.7a.89.89,0,0,0-.736-.389h-6.694a.986.986,0,0,1,0-1.973h6.694a2.861,2.861,0,0,1,2.366,1.25l4.96,7.275a2.867,2.867,0,0,1,2.714,2.859v6.729A2.866,2.866,0,0,1,426.116,269.634Z",
    transform: "translate(-374.602 -241.6)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38312",
    "data-name": "Path 38312",
    d: "M448.408,280.193h-7.649a2.866,2.866,0,0,1-2.863-2.863V274.37a.986.986,0,1,1,1.973,0v2.959a.891.891,0,0,0,.89.89h7.649a.986.986,0,0,1,0,1.973Z",
    transform: "translate(-398.269 -262.642)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipping);
export default __webpack_public_path__ + "static/media/shipping.55421e1a54d9551f25a66d923421e6a6.svg";
export { ForwardRef as ReactComponent };